import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fbce60c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "crypto-choice-card"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
    key: 1,
    class: "crypto-choice-card empty-list"
};
import CryptoChoiceCard from '@/materials/molecules/CryptoChoiceCard.vue';
import { useStaking } from '@/logics/staking';
import { useMessage } from '@/const/messages';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean }
    },
    emits: ["selectCurrency"],
    setup(__props, { emit }) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const lists = ref();
            const { getStakingCurrencyLists, getStakingCurrencyListsUnlogin } = useStaking();
            if (props.isAuth) {
                lists.value = (([__temp, __restore] = _withAsyncContext(() => getStakingCurrencyLists())),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            else {
                lists.value = (([__temp, __restore] = _withAsyncContext(() => getStakingCurrencyListsUnlogin())),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            const { CHOICECARD, format } = useMessage();
            const setSelectedCurrency = (cryptoId, cryptoName, interestRate, isDisabled) => {
                if (interestRate === 0 || isDisabled === true) {
                    return;
                }
                emit('selectCurrency', { id: cryptoId, cryptoName: cryptoName });
            };
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", null, [
                    (lists.value.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, (currency) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: currency.cryptoName,
                                    class: _normalizeClass(["card", {
                                            'is-disabled': currency.interestRate === 0 || currency.isDisabled,
                                        }]),
                                    onClick: ($event) => (setSelectedCurrency(currency.id, currency.cryptoName, currency.interestRate, currency.isDisabled))
                                }, [
                                    _createVNode(CryptoChoiceCard, {
                                        "crypto-name": currency.cryptoName,
                                        "interest-rate": currency.interestRate
                                    }, null, 8, ["crypto-name", "interest-rate"])
                                ], 10, _hoisted_2));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("p", null, _toDisplayString(_unref(format)(_unref(CHOICECARD).EMPTY)), 1)
                        ]))
                ]));
            };
        });
    }
});
